import { getSocket } from '@/utils/socket';
import { NotificationSearchType } from '@entities/notification';
import { NotificationEntity } from '@api/types/notifications';
import { useGetNotifications, useGetUser } from '@api/user/hooks';
import { ReactNode, createContext, useEffect, useState } from 'react';

export const NotificationContext = createContext<{
  notification: NotificationEntity | null;
  isUserHasNotification: boolean;
  getUserNotifications: () => void;
}>({
  notification: null,
  isUserHasNotification: false,
  getUserNotifications: async () => {},
});

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
  const [notification, setNotification] = useState<NotificationEntity | null>(null);
  const { data: userData } = useGetUser();
  const user = userData?.user;

  const { data: allNotifications, refetch: refetchAll } = useGetNotifications(
    NotificationSearchType.all,
  );

  const isUserHasNotification = (allNotifications?.length || 0) > 0;

  useEffect(() => {
    const isSupported =
      'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;
    if (!isSupported) return;
    const socket = getSocket();

    socket.on('notification', (response) => {
      setNotification(response);
      showBrowserNotification();
      getUserNotifications();
    });

    requestNotificationPermission();

    // return () => {
    //   console.log(123333);
    //   socket.disconnect();
    // };
  }, [user?.id]);

  const getUserNotifications = async () => {
    await refetchAll();
  };

  const requestNotificationPermission = () => {
    if (Notification.permission !== 'granted') {
      void Notification.requestPermission();
    }
  };

  const showBrowserNotification = () => {
    if (Notification.permission === 'granted') {
      const notification = new Notification('New notification', {
        body: 'Please check notification page.',
      });
      notification.onclick = () => {
        window.open(
          process.env.REACT_APP_API_URL?.includes('localhost')
            ? 'http://localhost:3000/notifications'
            : 'https://aivo-website.netlify.app/notifications',
        );
      };
    }
  };

  return (
    <NotificationContext.Provider
      value={{
        notification,
        isUserHasNotification,
        getUserNotifications,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
